import React from "react";
import { useLocation } from "react-router-dom";
import Account from "../components/Accounts/Account";
import { isCustomerLoggedIn } from "../utils/CustomerAuth";
import BreadcrumbTwo from "../components/BreadcrumbTwo";

const AccountPage = () => {
  const location = useLocation();
  const isLoggedIn = isCustomerLoggedIn();

  const getTitle = () => {
    if (isLoggedIn) return "My Account";

    if (location.pathname === "/signup" || location.pathname === "/register") {
      return "Register";
    }

    return "Login";
  };

  return (
    <>
      <BreadcrumbTwo title={getTitle()} />
      <Account />
    </>
  );
};

export default AccountPage;